import { creatMapAndListSync } from 'presentation/libs/MapAndListSync/MapAndListSync'

const ListPreviewMapAndListSync = creatMapAndListSync()

export default ListPreviewMapAndListSync
